<template>
  <DataTable
    :value="invitations"
    :loading="isFetching"
  >
    <template #empty>
      <p>{{ $t('components.structural.organization.dialog.tabs-content.members-tab.tabs.invitations.table.empty.text') }}</p>
    </template>

    <template #loading>
      <ProgressSpinner
        style="width: 48px; height: 48px"
        stroke-width="3"
      />
    </template>

    <Column
      field="email"
      :header="$t('components.structural.organization.dialog.tabs-content.members-tab.tabs.invitations.table.headers.email')"
    />
    <Column
      field="role"
      :header="$t('components.structural.organization.dialog.tabs-content.members-tab.tabs.invitations.table.headers.role')"
    >
      <template #body="slotProps">
        <p>{{ getRoleName(slotProps.data.role) }}</p>
      </template>
    </Column>
    <component
      :is="customColumnsComponent"
      v-if="hasCustomColumns"
    />
    <Column
      style="width: 10%; min-width: 8rem"
      body-style="text-align:center"
    >
      <template #body="slotProps">
        <Button
          :label="$t('common.cta.cancel')"
          size="small"
          :loading="currentInvitationIdCanceling === slotProps.data.id"
          @click="cancelOrganizationInvitation(slotProps.data.id)"
        />
      </template>
    </Column>
  </DataTable>
</template>

<script lang="ts" setup>
import { deleteDoc, doc } from '@firebase/firestore'
import type { Invitation } from '~/types/organizations/invitation'
import { SlotsComponents } from '~/constants/components/slots'
import { Collections } from '~/constants/firebase'
import { getRoleName } from '~/utils/user/role'

defineProps<{
  isFetching: boolean
  invitations: Invitation[]
}>()

const {
  isOverridden: hasCustomColumns,
  overriddenComponent: customColumnsComponent,
} = isComponentOverridden(SlotsComponents.OrganizationDialogInvitationsDataTables)

const currentInvitationIdCanceling = ref<string | null>(null)
const cancelOrganizationInvitation = async (invitationId: string) => {
  currentInvitationIdCanceling.value = invitationId
  await deleteDoc(
    doc(useGetFirestore(), Collections.OrganizationsInvitations, invitationId),
  )
  currentInvitationIdCanceling.value = null
}
</script>
